import React, { useEffect, useState } from 'react';
import styles from './ThresholdMarketingProgress.styles';
import { getTitleFromOffer } from './ThresholdMarketingProgress.service';
import { useAppSelector } from '../../redux/hook';
import { ORDER_TYPE_DELIVERY } from '../../constants';
import {
  MarketingCampaignType,
  Offer,
  ThresholdMarketingCampaignConfig,
} from '../../1_types/genericTypes';
import ProgressBar from '../ProgressBar/ProgressBar.view';
import { isStringNotNull } from '../../utils';
import _ from 'lodash';

export type ThresholdMarkertingProgressProps = {
  offer: Offer;
};

export default function ThresholdMarketingProgress({
  offer,
}: ThresholdMarkertingProgressProps) {
  const { isMobile } = useAppSelector((state) => state.componentReducer);
  const {
    totalProductPriceWithPromo,
    orderType,
    basketMarketingCampaignKey,
    commande,
  } = useAppSelector((state) => state.pendingOrderReducer);

  const [errorOccured, setErrorOccured] = useState(false);

  const config = offer.config as ThresholdMarketingCampaignConfig;
  const isValid = !(
    offer.type === MarketingCampaignType.FREE_DELIVERY_AFTER_THRESHOLD &&
    orderType !== ORDER_TYPE_DELIVERY
  );

  useEffect(() => {
    if (isStringNotNull(basketMarketingCampaignKey)) setErrorOccured(false);
  }, [basketMarketingCampaignKey, totalProductPriceWithPromo]);

  return !isValid || errorOccured ? (
    <></>
  ) : (
    <div
      style={{
        ...styles.floatingThresholdProgressContainer,
        ...(isMobile && !_.isEmpty(commande) ? { bottom: 65, left: 10 } : {}),
      }}
    >
      <div style={styles.floatingThresholdTitleContainer}>
        <img
          src='/assets/thresholdMarketing.png'
          height={26}
          width={26}
        />
        <div>
          <p style={styles.floatingThresholdTitle}>
            {getTitleFromOffer(offer)}
          </p>
          {offer.type ===
            MarketingCampaignType.PRODUCT_DISCOUNT_AFTER_THRESHOLD && (
            <p style={styles.floatingThresholdSubTitle}>
              *Sur une sélection de produits
            </p>
          )}
        </div>
      </div>
      <div style={{ width: '100%', padding: '0 10px 10px 10px' }}>
        <ProgressBar
          isComplete={isStringNotNull(basketMarketingCampaignKey)}
          progress={Math.min(
            1,
            Math.round(
              ((totalProductPriceWithPromo ?? 0) / config.threshold) * 100
            ) / 100
          )}
        />
      </div>
    </div>
  );
}
